import { useIsMobile } from '../landingpage/hooks/use-mobile';

export function useRouteForDevice() {
  const isMobile = useIsMobile();

  const getRoute = (routeName) => {
    const routeMap = {
      'review-details': isMobile ? '/review-details' : '/dashboard/review-details',
      'review-details-lease': isMobile ? '/review-details-lease' : '/dashboard/review-details-lease',
      'leads': isMobile ? '/leads' : '/dashboard/leads',
      'campaign-management': isMobile ? '/campaign-management' : '/dashboard/campaign-management',
      'campaign-overview': isMobile ? '/campaign-overview' : '/dashboard/campaign-overview',
      'profile': isMobile ? '/profile' : '/dashboard/profile',
      'account-details': isMobile ? '/account-details' : '/dashboard/account-details',
      'facebook-page': isMobile ? '/facebook-page' : '/dashboard/facebook-page',
      'whatsapp-template': isMobile ? '/whatsapp-template' : '/dashboard/whatsapp-template',
      'campaign-summary': isMobile ? '/campaign-summary' : '/dashboard/campaign-summary',
      'lease-campaign-summary': isMobile ? '/lease-campaign-summary' : '/dashboard/lease-campaign-summary',
      'transactions': isMobile ? '/transactions' : '/dashboard/transactions',
      'payment-successful': isMobile ? '/payment-successful' : '/dashboard/payment-successful',
      // Add more as needed
    };
    return routeMap[routeName] || '/';
  };

  return getRoute;
} 